import { KeyLabel } from '../domain/key-label.model';

export enum ReportVodStatus {
  OK = 'ok',
  REQUEST_NOT_SENT = 'request_not_sent',
  REQUEST_THROTTLED = 'request_throttled',
  REQUEST_ERROR = 'request_error',
  RESPONSE_NO_CONTENT = 'response_no_content',
  RESPONSE_ERROR = 'response_error'
}

export const ReportVodStatusLabels = {
  [ReportVodStatus.OK]: 'OK',
  [ReportVodStatus.REQUEST_NOT_SENT]: 'Request Not Sent',
  [ReportVodStatus.REQUEST_THROTTLED]: 'Request Throttled',
  [ReportVodStatus.REQUEST_ERROR]: 'Request Error',
  [ReportVodStatus.RESPONSE_NO_CONTENT]: 'Response No Content',
  [ReportVodStatus.RESPONSE_ERROR]: 'Response Error'
};

export const ReportVodStatusKL = () =>
  Object.keys(ReportVodStatus).map(key =>
    new KeyLabel<ReportVodStatus>(
      ReportVodStatus[key],
      ReportVodStatusLabels[ReportVodStatus[key]]
    )
  );

export const ReportVodStatusList = Object.values(ReportVodStatus);

